// extracted by mini-css-extract-plugin
module.exports = {"buttonDescription":"GetStarted_buttonDescription__140e1","button":"GetStarted_button__1pkXo"};